<button [ngClass]="[ribbonBg]" [disabled]="disabled" (click)="handleClick()" style="cursor: pointer;" 
>
    {{ label }}
</button>
